export default "__VITE_PUBLIC_ASSET__7c4aa2df__"